import { Box, Theme } from "@mui/system";
import { CircularProgress, Typography } from "@mui/material";
import Image from "next/image";
import { LoaderState } from "@/core/types/types";
import useCustomStyles from "@/core/hooks/useCustomStyles/useCustomStyles";
import { useTranslations as t } from "@/core/hooks/useTranslations/useTranslations";

interface WaitingStepProps {
  label: string;
  status: LoaderState;
}

const styles = (theme: Theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  iconContainer: {
    minWidth: 24,
    minHeight: 24,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  checkmark: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "@keyframes bounceIn": {
      "0%": {
        transform: "scale(0.5)",
      },
      "70%": {
        transform: "scale(1.1)",
      },
      "100%": {
        transform: "scale(1)",
      },
    },
    animation: "bounceIn 0.5s ease-out",
  },
  loading: {
    color: theme.palette.grey.A400,
  },
  active: {
    color: theme.palette.primary.main,
  },
});

const WaitingListStep = ({ label, status }: WaitingStepProps) => {
  const classes: any = useCustomStyles(styles);

  return (
    <Box sx={classes?.root}>
      <Box sx={classes.iconContainer}>
        {status === LoaderState.WAITING && (
          <CircularProgress
            sx={classes?.loading}
            variant={"determinate"}
            value={100}
            size={18}
            thickness={4}
          />
        )}
        {status === LoaderState.LOADING && (
          <CircularProgress sx={classes?.active} size={18} thickness={4} />
        )}
        {status === LoaderState.DONE && (
          <Box sx={classes?.checkmark}>
            <Image
              src="images/icons/checkmark.svg"
              width="18"
              height="18"
              alt="checkmark"
            />
          </Box>
        )}
      </Box>
      <Typography sx={status === LoaderState.WAITING ? classes?.loading : {}}>
        {t(label)}
      </Typography>
    </Box>
  );
};

export default WaitingListStep;
